export default __webpack_public_path__ + "static/media/char-darth-vader.5b9f93c0.jpg";